import {useState, useEffect} from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Divider,
  MenuItem,
  FormControlLabel,
  Switch,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const typeOptions = [
  {label: '일반', value: 'GENERAL'},
  {label: '알림', value: 'NOTICE'},
];
const roleTypeOptions = [
  {label: 'ALL', value: 'ALL'},
  {label: 'WRITE', value: 'WRITE'},
  {label: 'READ', value: 'READ'},
  {label: 'UPDATE', value: 'UPDATE'},
  {label: 'DELETE', value: 'DELETE'},
];
const userRoleTypeOptions = [
  {label: 'ROLE_ADMIN', value: 'ROLE_ADMIN'},
  {label: 'ROLE_NOTICE_ADMIN', value: 'ROLE_NOTICE_ADMIN'},
  {label: 'ROLE_USER', value: 'ROLE_USER'},
];

const initData = {
  name: '',
  type: "GENERAL",
  sort: 1,
  isEnable: true,
  boardRoleResList: [
    {
      roleType: "ALL",
      userRoleType: "ROLE_ADMIN"
    }
  ]
};

const makeRandomId = () => Math.random().toString(36).substr(2, 11);

const BoardItemModal = ({
  open,
  data,
  updateModal,
  closeModal
}) => {
  const [form, setForm] = useState(initData);
  const [isConfirm, setIsConfirm] = useState(false);

  const onChangeForm = (key, value) => {
    const updatedForm = Object.assign({}, form);
    updatedForm[key] = value;
    setForm(updatedForm);
  };

  const onChangeRoleForm = (itemId, key, value) => {
    const updatedForm = Object.assign({}, form);
    updatedForm.boardRoleResList = updatedForm.boardRoleResList.map(data => {
      const cloneData = Object.assign({}, data);
      if (data.id === itemId) {
        cloneData[key] = value;
      }
      return cloneData;
    });
    setForm(updatedForm);
  };

  const onAddRoleForm = () => {
    const updatedForm = Object.assign({}, form);
    const newItem = Object.assign({}, initData.boardRoleResList[0], {
      id: makeRandomId(),
    });
    updatedForm.boardRoleResList = [...updatedForm.boardRoleResList, newItem];
    setForm(updatedForm);
  };

  const onDeleteRoleForm = (itemId) => {
    const updatedForm = Object.assign({}, form);
    updatedForm.boardRoleResList = updatedForm.boardRoleResList.filter(data => itemId !== data.id);
    setForm(updatedForm);
  }

  const onUpdateModal = () => {
    setIsConfirm(true);
    if (!form.name) return;
    const reqForm = Object.assign({}, form);
    reqForm.boardRoleReqList = reqForm.boardRoleResList.map(data => {
      const cloneData = Object.assign({}, data);
      delete cloneData.id;
      return cloneData;
    });
    delete reqForm.boardRoleResList;
    updateModal(reqForm);
  };

  useEffect(() => {
    if (!data) return;
    const cloneData = Object.assign({}, data);
    cloneData.boardRoleResList = cloneData.boardRoleResList.map(data => {
      return Object.assign({}, data, {
        id: makeRandomId(),
      });
    })
    setForm(cloneData);
  }, [data]);

  return (
    <Dialog 
      open={open} 
      onClose={closeModal}
      fullWidth={true}
      maxWidth={'sm'}
    >
      <DialogTitle>게시판 {data ? '수정' : '추가'}</DialogTitle>
      <Divider />
      <DialogContent>
        <Stack spacing={3}>
          <TextField 
            label="게시판 이름" 
            variant="outlined" 
            size="small" 
            autoFocus
            defaultValue={form.name}
            onChange={(e) => onChangeForm('name', e.target.value)}
            required={true}
            error={isConfirm && !form.name}
          />
          <TextField
            select
            label="게시판 타입"
            defaultValue={form.type}
            size="small"
            onChange={(e) => onChangeForm('type', e.target.value)}
          >
            {typeOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <FormControlLabel
            control={
              <Switch 
                checked={form.isEnable} 
                color="info" 
                onChange={(e) => onChangeForm('isEnable', e.target.checked)} 
              />
            }
            label="활성화 상태"
          />
          {
            form.boardRoleResList.map((data, index) => {
              return <BoardRoleItem 
                key={index}
                index={index}
                data={data}
                onChangeRoleForm={onChangeRoleForm}
                onDeleteRoleForm={onDeleteRoleForm}
              />;
            })
          }
          <Button fullWidth size="small" variant="outlined" onClick={onAddRoleForm}>권한 추가</Button>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={onUpdateModal} color="info">{data ? '수정' : '추가'}</Button>
        <Button onClick={closeModal}>취소</Button>
      </DialogActions>
    </Dialog>
  );
}

const BoardRoleItem = ({
  data,
  index,
  onChangeRoleForm,
  onDeleteRoleForm
}) => {
  if (!data) return '';
  return (
    <Stack spacing={2} sx={{
      p: 2, 
      border: '1px solid #ccc', 
      position: 'relative', 
      backgroundColor: '#f9f9f9'
    }}>
      {index + 1}
      <IconButton aria-label="delete" sx={{position: 'absolute', right: 0, top: 0}} onClick={() => onDeleteRoleForm(data.id)}>
        <CloseIcon />
      </IconButton>
      <TextField
        select
        label="권한"
        value={data.roleType}
        size="small"
        onChange={(e) => onChangeRoleForm(data.id, 'roleType', e.target.value)}
      >
        {roleTypeOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        label="사용자 권한"
        value={data.userRoleType}
        size="small"
        onChange={(e) => onChangeRoleForm(data.id, 'userRoleType', e.target.value)}
      >
        {userRoleTypeOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
}

export default BoardItemModal;